module.exports = __webpack_public_path__ + "img/title_onestore.a01c51fc.png";